import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { formValueSelector } from 'redux-form';
import { innovidDimensionCount, dv360DimensionCount } from 'constants/platforms';
import SelectList from 'components/atoms/inputs/SelectList';

const getFormValue = formValueSelector('editDynamicProfile');

const createDimensionList = (meta, profileType) => {
    const list = [];
    const maxIndex = profileType === 'innovid' ? innovidDimensionCount : dv360DimensionCount;
    for (let index = 1; index <= maxIndex; index += 1) {
        const { label, showOnReport } = get(meta, `dimension${index}`, {});

        list.push({
            name: `Dimension ${index}${label ? ` (${label})` : ''}`,
            id: `dimension${index}`,
            disabled: !(label && showOnReport)
        });
    }
    return list;
};

const DimensionPivotSelectContainer = (props) => {
    const { input, meta } = props;
    return (
        <SelectList input={input} list={useMemo(() => createDimensionList(meta), [meta])}/>
    );
};

const mapStateToProps = state => ({
    meta: getFormValue(state, 'meta')
});

export default connect(mapStateToProps)(DimensionPivotSelectContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/dynamicProfiles/DimensionPivotSelectContainer.js